import { CommunicationSettingType } from './communications/communication-settings';
import { User } from './user';

export class ClinicEmailTemplate {
  id: number = 0;
  emailTemplateType: EmailTemplateType;
  name: string;
  description: string;
  definition: string;
  html: string;
  createdByUser: User = null;
  createdDate: Date = new Date(Date.now());
  modifiedByUser: User = null;
  modifiedDate: Date = new Date();
}

export enum EmailTemplateType {
  AppointmentReminder = 1,
  RetentionCampaign = 2,
  Reviews = 3,
  PortalWelcome = 4,
  PortalPasswordReset = 5,
  PortalSetPassword = 6,
  PortalDocument = 7,
  AppointmentScheduled = 8,
  AppointmentChanged = 9,
  AppointmentCancelled = 10,
  RequestCreditCard = 11,
  GiftCardPurchase = 12,
  FormsReminder = 13,
  CreditCardReminder = 14,
}

export function getEmailTemplateType(settingType: CommunicationSettingType) {
  switch (settingType) {
    case CommunicationSettingType.ScheduledConfirmation:
      return EmailTemplateType.AppointmentScheduled;
    case CommunicationSettingType.ChangedConfirmation:
      return EmailTemplateType.AppointmentChanged;
    case CommunicationSettingType.CancelledConfirmation:
      return EmailTemplateType.AppointmentCancelled;
    case CommunicationSettingType.VisitReminder:
      return EmailTemplateType.AppointmentReminder;
    case CommunicationSettingType.GiftCardPurchase:
      return EmailTemplateType.GiftCardPurchase;
    case CommunicationSettingType.FormsReminder:
      return EmailTemplateType.FormsReminder;
    case CommunicationSettingType.CreditCardReminder:
      return EmailTemplateType.CreditCardReminder;
    default:
      return null;
  }
}
